import { makeStyles } from '@material-ui/core/styles'
import styled, { css } from 'styled-components'

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: '0 3.3rem',
    paddingTop: 29,
    paddingBottom: 10,
    display: 'grid',
    gridTemplateColumns: 'minmax(90%, 1500px)',
    gridAutoRows: 'min-content',
    justifyContent: 'center',
  },
  h1: {
    marginTop: 12,
    fontSize: 21,
    color: theme.palette.common.second1,
    marginRight: 5,
  },
  button: {
    fontWeight: 'normal',
    fontSize: 14,
    textTransform: 'none',
    minWidth: 130,
    height: 38,
    color: theme.palette.common.second8,
    backgroundColor: '#D57800',
    display: 'none',
    '&:hover': {
      backgroundColor: '#D57800',
    },
  },
}))

export const ToolBar = styled.div`
  ${() => css`
    display: grid;
    grid-template-areas: 'history info' 'filters info';
    width: 100%;
    max-width: 1500px;
  `}
`
